import { ClassRating } from "constants/rate-classes";

export const userFeedbackEvents = {
  liveClassDetailedFeedbackFreeText: "live class detailed feedback free text",
  liveClassDetailedFeedbackSubmit: "live class detailed feedback submitted",
  liveClassDetailedFeedbackPageViewed:
    "live class detailed feedback page viewed",
  liveClassFeedbackSubmitted: "live class feedback submitted",
  liveClassFeedbackDismissed: "live class feedback dismissed",
  liveClassPositiveFeedbackSelected: "live class positive feedback selected",
  liveClassNeutralFeedbackSelected: "live class neutral feedback selected",
  liveClassNegativeFeedbackSelected: "live class negative feedback selected"
};

export const getEventBasedOnRating = (selectedRating: ClassRating): string => {
  switch (selectedRating) {
    case ClassRating.POSITIVE:
      return userFeedbackEvents.liveClassPositiveFeedbackSelected;
    case ClassRating.NEUTRAL:
      return userFeedbackEvents.liveClassNeutralFeedbackSelected;
    case ClassRating.NEGATIVE:
      return userFeedbackEvents.liveClassNegativeFeedbackSelected;
  }
};
